import React, { useEffect } from "react";
import { motion } from "framer-motion";
import Isotipo from "./Isotipo";
import { useLang } from "@/context/LanguageContext";

const EASE = [0.22, 1, 0.36, 1];

// Pretty startup animation: GR▲BARTE lockup reveal + "Desde 2007 · 20 años de experiencia".
const IntroAnimation = ({ onDone }) => {
  const { t } = useLang();

  useEffect(() => {
    const x = setTimeout(onDone, 3000);
    return () => clearTimeout(x);
  }, [onDone]);

  const word = { fontSize: "clamp(2.1rem, 8vw, 3.75rem)", letterSpacing: "-0.01em" };

  return (
    <motion.div
      data-testid="intro-animation"
      onClick={onDone}
      className="fixed inset-0 z-[200] flex items-center justify-center overflow-hidden cursor-pointer"
      style={{ backgroundColor: "#171726" }}
      exit={{ opacity: 0, filter: "blur(6px)", transition: { duration: 0.7, ease: EASE } }}
    >
      {/* soft glow */}
      <motion.div
        className="absolute pointer-events-none"
        style={{ width: 680, height: 680, borderRadius: "50%", background: "radial-gradient(circle, rgba(237,170,81,0.16), transparent 62%)" }}
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1.6, ease: EASE }}
      />

      <div className="relative flex flex-col items-center px-6 text-center">
        <div className="flex items-center justify-center">
          <motion.span
            className="font-display font-black uppercase leading-none text-white"
            style={word}
            initial={{ opacity: 0, x: -26 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7, delay: 0.55, ease: EASE }}
          >
            GR
          </motion.span>
          <motion.span
            className="mx-[2px] inline-flex"
            initial={{ opacity: 0, scale: 0.3, rotate: -25 }}
            animate={{ opacity: 1, scale: 1, rotate: 0 }}
            transition={{ duration: 0.9, delay: 0.15, ease: EASE }}
          >
            <Isotipo style={{ height: "clamp(1.7rem, 6vw, 2.9rem)", transform: "translateY(2px)" }} fill="#edaa51" />
          </motion.span>
          <motion.span
            className="font-display font-black uppercase leading-none text-white"
            style={word}
            initial={{ opacity: 0, x: 26 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7, delay: 0.55, ease: EASE }}
          >
            BARTE
          </motion.span>
        </div>

        <motion.div
          className="mt-8 h-px"
          style={{ backgroundColor: "#edaa51" }}
          initial={{ width: 0 }}
          animate={{ width: 150 }}
          transition={{ duration: 0.8, delay: 1.15, ease: EASE }}
        />

        <motion.p
          className="mt-6 font-display text-[11px] md:text-xs font-bold uppercase tracking-[0.42em] text-brand-gold"
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 1.35 }}
        >
          {t({ es: "Desde 2007", en: "Since 2007" })}
        </motion.p>
        <motion.p
          className="mt-2.5 font-body text-sm md:text-base text-white/70"
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 1.55 }}
        >
          {t({ es: "20 años de experiencia", en: "20 years of experience" })}
        </motion.p>
      </div>
    </motion.div>
  );
};

export default IntroAnimation;
